import moment from "moment";
import { DATE_MONTH_FORMAT } from "dash-common";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { useTheme } from "styled-components";
import {
  Flex,
  Avatar,
  Button,
  Text,
  Icon,
  ViewerContext,
  ExpandableText,
  FileList,
  ModalContext,
} from "dash-ui";
import { downloadDocumentFile } from "common/helpers/downloadMedia";
import { IPropertyNoteListItem } from "containers/properties/PropertyNote/components/PropertyNoteList/PropertyNoteListItem/PropertyNoteListItem.interfaces";

const PropertyNotesListItem = ({
  item: note,
  onEditIconClick,
}: IPropertyNoteListItem) => {
  const { t } = useTranslation(["common"]);
  const theme = useTheme();
  const { account } = useContext(ViewerContext);
  const isRead = note.readBy.includes(account?._id || "");
  const { toggleModal, setPayload } = useContext(ModalContext);

  return (
    <Flex mt={4} w="100%" flexDirection="column">
      <Flex
        w="100%"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex mr={3}>
          <Avatar
            firstName={note.authorProfile?.firstName}
            lastName={note.authorProfile?.lastName || undefined}
            url={note.authorProfile?.avatarFile?.publicUrl}
          />
        </Flex>
        <Flex flex={1} flexDirection="column">
          <Flex>
            <Text semibold>
              {note.authorProfile?.firstName || ""}{" "}
              {note.authorProfile?.lastName || ""}
            </Text>
          </Flex>
          <Flex alignItems="center">
            <Text color={theme.colors.n80}>
              {moment(note.createdAt).format(`${DATE_MONTH_FORMAT}, hh:mm`)}
              &nbsp;&#x2022;&nbsp;
            </Text>
            <Icon
              mr={1}
              name={isRead ? "doneAll" : "timelapse"}
              color={isRead ? theme.colors.g20 : theme.colors.b50}
            />
            <Text color={isRead ? theme.colors.g20 : theme.colors.b50}>
              {isRead ? t("common:labels:read") : t("common:labels:newNote")}
            </Text>
          </Flex>
        </Flex>
        <Flex alignItems="center">
          <Button
            onClick={() => onEditIconClick(note._id)}
            icon="edit"
            medium
            variation="flat"
            disabled={note.authorAccount?._id !== account?._id}
          >
            {t("common:labels:edit")}
          </Button>
          <Button
            onClick={() => {
              toggleModal(true, "DeletePropertyNoteModal");
              setPayload({ propertyNoteId: note._id });
            }}
            disabled={note.authorAccount?._id !== account?._id}
            icon="trash"
            medium
            variation="flat"
            colorVariation="danger"
          >
            {t("common:labels:delete")}
          </Button>
        </Flex>
      </Flex>
      <Flex pl={13} mt={1} flexDirection="column">
        <ExpandableText lineClamp={10}>{note.message}</ExpandableText>
      </Flex>
      {note.attachedFiles && (
        <Flex pl={13} mt={1} flexDirection="column">
          <FileList
            files={note.attachedFiles?.map((file) => ({
              _id: file._id,
              name: file.name,
              onClick: () => downloadDocumentFile(file),
            }))}
          />
        </Flex>
      )}
    </Flex>
  );
};

export default PropertyNotesListItem;
